import useAuth from '@modules/AuthModule/hooks/useAuth';

const AuthPanel = () => {
  const auth = useAuth();
  return (
    <div>
      <pre>{JSON.stringify(auth, undefined, 2)}</pre>
    </div>
  );
};

export default AuthPanel;
